// extracted by mini-css-extract-plugin
module.exports = {"pageLink":"_dJ"};